export default __webpack_public_path__ + "static/media/mobile_logo.73d27be1.svg";